module.exports = __webpack_public_path__ + "static/media/story1.b70fc23.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bad/story1.mp4
// module id = F+Jm
// module chunks = 0